module.exports = __webpack_public_path__ + "img/TZS09457.cfb0cbe4.jpeg";